var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57812 9.84375L10 5.42188L9.28125 4.71875L5.57812 8.42188L3.70312 6.54688L3 7.25L5.57812 9.84375ZM6.5 13.25C5.64583 13.25 4.83854 13.0859 4.07812 12.7578C3.31771 12.4297 2.65365 11.9818 2.08594 11.4141C1.51823 10.8464 1.07031 10.1823 0.742187 9.42188C0.414062 8.66146 0.25 7.85417 0.25 7C0.25 6.13542 0.414062 5.32292 0.742187 4.5625C1.07031 3.80208 1.51823 3.14062 2.08594 2.57813C2.65365 2.01563 3.31771 1.57031 4.07812 1.24219C4.83854 0.914062 5.64583 0.75 6.5 0.75C7.36458 0.75 8.17708 0.914062 8.9375 1.24219C9.69792 1.57031 10.3594 2.01563 10.9219 2.57813C11.4844 3.14062 11.9297 3.80208 12.2578 4.5625C12.5859 5.32292 12.75 6.13542 12.75 7C12.75 7.85417 12.5859 8.66146 12.2578 9.42188C11.9297 10.1823 11.4844 10.8464 10.9219 11.4141C10.3594 11.9818 9.69792 12.4297 8.9375 12.7578C8.17708 13.0859 7.36458 13.25 6.5 13.25Z",
    fill: "#7AA431"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOn);
export default __webpack_public_path__ + "static/media/icon_on.46065a36a63f370789d75e835cecb539.svg";
export { ForwardRef as ReactComponent };